const fileName = {
    name: 'Riverpoker',
    buildForLive: false,
    optimizeUrl: true
    // name: localStorage.getItem("url"),
    // name:'Riverpoker'
    // name: 'Riverpoker',
}
export default fileName;
